var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (results, undefined) {
// iterate results
;(function(){
  var $$obj = results;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artist = $$obj[$index];

buf.push("<div class=\"mgr-cell js-mgr-cell artist-rail-cell\"><div class=\"artist-cell-item\"><a" + (jade.attr("href", artist.href, true, true)) + " class=\"artist-rail-cell__link artist-cell-item__link artist-rail-hoverable\"><div class=\"hoverable-image-link\"><div" + (jade.attr("data-initials", artist.initials, true, true)) + (jade.attr("style", artist.image && 'background-image: url(' + (artist.image.cropped.url) + ')', true, true)) + " class=\"hoverable-image is-four-three is-cropped\"></div></div><div class=\"artist-cell-item__artist-information\"><div class=\"artist-cell-item__artist-name\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</div><div class=\"artist-cell-item__bio\">");
if ( artist.formatted_nationality_and_birthday)
{
buf.push(jade.escape(null == (jade_interp = artist.formatted_nationality_and_birthday) ? "" : jade_interp));
}
buf.push("</div><div class=\"artist-cell-item__followers\">");
if ( artist.counts)
{
var total = artist.counts.artworks || 0
var for_sale = artist.counts.for_sale_artworks || 0
buf.push(jade.escape(null == (jade_interp = total + (total > 1 ? ' works' : ' work')) ? "" : jade_interp));
if ( total != for_sale)
{
buf.push(jade.escape(null == (jade_interp = ', ' + for_sale) ? "" : jade_interp));
}
buf.push(" for sale");
}
buf.push("</div></div></a><a" + (jade.attr("data-id", artist.id, true, true)) + " class=\"artist-cell-item__follow-button avant-garde-follow-button-black follow-button is-small\"></a></div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artist = $$obj[$index];

buf.push("<div class=\"mgr-cell js-mgr-cell artist-rail-cell\"><div class=\"artist-cell-item\"><a" + (jade.attr("href", artist.href, true, true)) + " class=\"artist-rail-cell__link artist-cell-item__link artist-rail-hoverable\"><div class=\"hoverable-image-link\"><div" + (jade.attr("data-initials", artist.initials, true, true)) + (jade.attr("style", artist.image && 'background-image: url(' + (artist.image.cropped.url) + ')', true, true)) + " class=\"hoverable-image is-four-three is-cropped\"></div></div><div class=\"artist-cell-item__artist-information\"><div class=\"artist-cell-item__artist-name\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</div><div class=\"artist-cell-item__bio\">");
if ( artist.formatted_nationality_and_birthday)
{
buf.push(jade.escape(null == (jade_interp = artist.formatted_nationality_and_birthday) ? "" : jade_interp));
}
buf.push("</div><div class=\"artist-cell-item__followers\">");
if ( artist.counts)
{
var total = artist.counts.artworks || 0
var for_sale = artist.counts.for_sale_artworks || 0
buf.push(jade.escape(null == (jade_interp = total + (total > 1 ? ' works' : ' work')) ? "" : jade_interp));
if ( total != for_sale)
{
buf.push(jade.escape(null == (jade_interp = ', ' + for_sale) ? "" : jade_interp));
}
buf.push(" for sale");
}
buf.push("</div></div></a><a" + (jade.attr("data-id", artist.id, true, true)) + " class=\"artist-cell-item__follow-button avant-garde-follow-button-black follow-button is-small\"></a></div></div>");
    }

  }
}).call(this);
}.call(this,"results" in locals_for_with?locals_for_with.results:typeof results!=="undefined"?results:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;